import { ImageUploadProvider } from 'src/app/shared/hooks/imageUpload';

import { CreatePetitionUpdateForm } from './components/CreatePetitionUpdateForm';
import { CreatePetitionUpdateContext } from './components/CreatePetitionUpdateForm/context';
import { FilledTemplateNotice } from './components/FilledTemplateNotice';
import { Header } from './components/Header';
import { SuggestedTemplateNotice } from './components/SuggestedTemplateNotice';
import { useUpdateSupporters } from './hooks/useUpdateSupporters';

export function UpdateSupporters() {
	const {
		data: { shouldShowSuggestedTemplateNotice, isTemplateFilled },
		actions: { handleUserClickSuggestionAi },
	} = useUpdateSupporters();

	return (
		<section
			aria-labelledby="update-your-supporters-module"
			data-qa="update-your-supporters-module"
			className="bg-background-base p-4 py-8 md:px-12 md:pt-8 md:pb-12 lg:pt-12"
		>
			<Header />
			{shouldShowSuggestedTemplateNotice && (
				<SuggestedTemplateNotice data-qa="suggested-template-notice" onClick={handleUserClickSuggestionAi} />
			)}
			{isTemplateFilled && <FilledTemplateNotice />}
			<CreatePetitionUpdateContext.Provider value={isTemplateFilled}>
				<ImageUploadProvider>
					<CreatePetitionUpdateForm />
				</ImageUploadProvider>
			</CreatePetitionUpdateContext.Provider>
		</section>
	);
}
